export const removeNewLineFn = (text) => {
  if (!text) {
    return '';
  }
  return String(text)
    .replace(/(\r\n|\n|\r)/gm, '')
    .trim();
};
